export const REQUEST_USERS = 'dt/ad/REQUEST_USERS';
export const REQUEST_LIMITED_USERS = 'dt/ad/REQUEST_LIMITED_USERS';
export const RECEIVE_USERS = 'dt/ad/RECEIVE_USERS';
export const RECEIVE_LIMITED_USERS = 'dt/ad/RECEIVE_LIMITED_USERS';
export const REQUEST_USER = 'dt/ad/REQUEST_USER';
export const RECEIVE_USER = 'dt/ad/RECEIVE_USER';
export const DELETE_USER = 'dt/ad/DELETE_USER';

export const requestUsers = () => ({
  type: REQUEST_USERS,
});

export const requestLimitedUsers = (siteId) => ({
  type: REQUEST_LIMITED_USERS,
  siteId,
});

export const receiveUsers = (users) => ({
  type: RECEIVE_USERS,
  users,
});

export const receiveLimitedUsers = (users) => ({
  type: RECEIVE_LIMITED_USERS,
  users,
});

export const requestUser = (oid) => ({
  type: REQUEST_USER,
  oid,
});

export const receiveUser = (oid, user) => ({
  type: RECEIVE_USER,
  oid,
  user,
});

export const deleteUser = (oid) => ({
  type: DELETE_USER,
  oid,
});
